export default "__VITE_ASSET__a28ee221__"